import script from "./Services.vue?vue&type=script&setup=true&lang=js"
export * from "./Services.vue?vue&type=script&setup=true&lang=js"

import "./Services.vue?vue&type=style&index=0&id=0a77622a&lang=scss"

const __exports__ = script;

export default __exports__